export const EDIT_TOOL_NAME = 'Edit Group';

export const EDIT_GROUP_TASK = 'edit-group';
export const EDIT_GROUP_REQUEST_MESSAGE = 'Updating group in progress...';

export const DELETE_TOOL_NAME = 'Delete Group';
export const DELETE_GROUP_TASK = 'delete-group';
export const DELETE_GROUP_REQUEST_MESSAGE = 'Deleting group in progress...';
export const DELETE_BUTTON_TOOLTIP = 'Deleting the Group will unassign all members from it. The access to searches' +
    ' and lists associated with the Group will be lost for collaborators.';
